import type { DropdownMenuContentProps, DropdownMenuItemProps } from '@radix-ui/react-dropdown-menu';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';

export const AccountSelectMenuContent = forwardRef<
  React.ElementRef<typeof DropdownMenu.Content>,
  DropdownMenuContentProps
>((props: DropdownMenuContentProps, forwardedRef) => {
  return (
    <DropdownMenu.Content
      {...props}
      ref={forwardedRef}
      className="max-h-60 overflow-auto z-max p-1 bg-bolt-elements-background-depth-2 border rounded-lg border-bolt-elements-borderColor text-sm"
    />
  );
});

export function AccountSelectMenuItem(props: DropdownMenuItemProps) {
  return (
    <DropdownMenu.Item
      {...props}
      className="min-w-52 outline-none cursor-pointer flex items-center rounded-lg gap-3 px-2.5 py-1.5 hover:bg-bolt-elements-item-backgroundActive"
    />
  );
}
